import { Icon } from "@circle-react/components/shared/Icon";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { PageHeaderWithPortal } from "./Header/HeaderWithPortal";

export interface BreadcrumbProps {
  backLink?: string;
  backLinkText?: string;
  className?: string;
  customRightContent?: ReactNode;
  hasBorder?: boolean;
  hidden?: boolean;
}

export const Breadcrumb = ({
  hidden = false,
  backLink = "",
  backLinkText = t("back"),
  customRightContent,
  className,
  hasBorder = true,
}: BreadcrumbProps) => {
  const navigate = useNavigate();
  const { isViewOnlyMasquerading } = usePunditUserContext();
  if (hidden || !backLink) return null;

  return (
    <PageHeaderWithPortal
      hasBorder={hasBorder}
      className={className}
      leftContent={
        <Button
          type="button"
          variant="text"
          extraLarge
          onClick={() => void navigate({ to: backLink })}
          className={classNames("flex items-center gap-2", {
            // Overrides the `!pointer-events-none` that PageHeader
            // cascades onto the leftContent wrapper for VOM admins,
            // keeping the back button interactive.
            "!pointer-events-auto": isViewOnlyMasquerading,
          })}
        >
          <Icon type="20-arrow-left" size={20} />
          {backLinkText}
        </Button>
      }
      rightContent={customRightContent ?? null}
    />
  );
};
